import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const usePaymentDetails = ({ 
  page = 1, 
  rows = 20, 
  consultationDateFrom = null, 
  consultationDateTo = null, 
  paymentStatus = null, 
  enabled = true,
  refetchOnWindowFocus = true
}) => {
  const tenant =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  const fetchPaymentDetails = async () => {
    const axiosInstance = createAxiosInstance();
    const params = new URLSearchParams({
      page: page.toString(),
      rows: rows.toString(),
    });

    if (consultationDateFrom) {
      params.append('consultationDateFrom', consultationDateFrom);
    }
    if (consultationDateTo) {
      params.append('consultationDateTo', consultationDateTo);
    }
    if (paymentStatus) {
      params.append('paymentStatus', paymentStatus);
    }

    const response = await axiosInstance.get(
      `${tenant}/consultationpaymentdue/report/payment-details/paginated?${params.toString()}`
    );

    return response.data;
  };

  return useQuery({
    queryKey: ["paymentDetails", tenant, page, rows, consultationDateFrom, consultationDateTo, paymentStatus],
    queryFn: fetchPaymentDetails,
    enabled: enabled && !!tenant,
    refetchOnWindowFocus: refetchOnWindowFocus,
    staleTime: 5 * 60 * 1000,
  });
};

export { usePaymentDetails };